import { render } from "./form-wrapper.vue?vue&type=template&id=14a3d918"
import script from "./form-wrapper.vue?vue&type=script&lang=js"
export * from "./form-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__